import PropTypes from 'prop-types';
import cx from 'classnames';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import IconCardGridBody from './Body';

const View = ({ data, path, metadata, className }) => {
  const columns = Number(data?.columns) || 2;

  return (
    <div
      className={cx(
        'block',
        'csjIconCardGrid',
        {
          'csjIconCardGrid--cols-3': columns === 3,
        },
        className,
      )}
    >
      <IconCardGridBody data={data} path={path} metadata={metadata} />
    </div>
  );
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  path: PropTypes.string,
  metadata: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string,
};

export default withBlockExtensions(View);
